import { Card, CardContent, Skeleton, Stack } from '@mui/material'
import { FC } from 'react'
import { SkeletonText } from 'utoniq-ui'

export const ItemSelectBoxSkeleton: FC = () => (
  <Card elevation={0}>
    <CardContent sx={{ p: 5, '&:last-child': { pb: 5 } }}>
      <Stack direction="row" spacing={4}>
        <Skeleton variant="rectangular" width={60} height={96} />
        <Stack flex={1}>
          <SkeletonText variant="medium" numberOfLine={2} />
          <Stack direction="row">
            <Stack flex={1}>
              <SkeletonText variant="small" width="50%" />
              <SkeletonText variant="small" width="25%" />
            </Stack>
          </Stack>
        </Stack>
        <Stack spacing={3}>
          <Skeleton variant="circular" width={28} height={28} />
          <Skeleton variant="circular" width={28} height={28} />
        </Stack>
      </Stack>
    </CardContent>
  </Card>
)
